module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-20 at 3.14.56 PM.4e96364f.jpeg";